import Modal from "./_bootstrapModalExtensions";
import * as Url from "./Utils/UrlUtil";

jQuery(() => {
    $(document).on('click', '[data-partnershare-resend]', (event: JQuery.ClickEvent) => {

        let target = $(event.target);

        let partnerId = target.data('partnershare-resend-partnerid');

        let urlTemplate = window.ETDR_RD.appConfig["UrlTemplate.ReSendSharing"];
        let url = Url.createUrlFromTemplate(urlTemplate, { partnerId: partnerId });

        $.ajax(url)
            .done(() => {
                Modal.showAlertWindow('E-mail újraküldése sikeresen megtörtént', 'Siker!');
            }).
            fail(() => {
                Modal.showAlertWindow('E-mail újraküldése sikertelen, kérem próbálja később!', 'Hiba!')
            });

        event.preventDefault();
    });
});
